import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import Location from 'App/Vehicles/shared/Location';
import React from 'react';
import styled from 'styled-components';

import useSurfaces from 'core/hooks/useSurfaces';
import { Thousands } from 'Elements/Formats';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';

import { Schema as SurfaceParamsSchema } from './schema';

const Row = styled(GridRow)`
  grid-template-columns: minmax(150px, 1fr) 150px 100px 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: SurfaceParamsSchema;
};

export default function SurfacesTable({ params }: Props) {
  const { data, loading, hasMore, loadMore } = useSurfaces(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Rengas</Column>
          <Column>Paikka</Column>
          <Column>Ura</Column>
          <Column>€/km</Column>
          <Column>Ajettu km</Column>
        </Row>
      </Header>

      <Body>
        {data.map(surface => (
          <Row key={surface.id}>
            <Column>
              <Grid spacing={1} container direction="row">
                <Grid item>{surface.product.name}</Grid>
              </Grid>

              <Typography variant="subtitle1">
                <Grid container spacing={1}>
                  <Grid item>ID: {surface.tire_id.substr(0, 8)}</Grid>
                  <Grid item>
                    {surface.tire.owner ? surface.tire.owner.company : ''}
                  </Grid>
                </Grid>
              </Typography>
            </Column>

            <Column>
              <Grid spacing={1} container direction="row">
                <Grid item>
                  {surface.tire && surface.tire.location_id && (
                    <Location id={surface.tire.location_id} />
                  )}
                  {surface.tire.slot && surface.tire.slot.title}
                </Grid>
              </Grid>

              <Typography variant="subtitle1">
                <Grid container spacing={1}>
                  <Grid item>
                    {surface.tire.customer ? surface.tire.customer.company : ''}
                  </Grid>
                </Grid>
              </Typography>
            </Column>
            <Column>{+surface.track_depth} mm</Column>
            <Column>–</Column>

            <Column>
              <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Thousands>{surface.kilometers}</Thousands>
                </Grid>
              </Grid>
            </Column>
          </Row>
        ))}

        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">Ei enempää renkaita</Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
